import { stats, voices } from "@/mocks/gossip";
import { SectionHead } from "./ui";

const steps = [
  { no: "1", icon: "ri-focus-3-line", title: "先看阶段标签", desc: "实锤、反转、辟谣、冷场一目了然，别被一段断章取义的视频带着走。" },
  { no: "2", icon: "ri-list-check-3", title: "再看证据链", desc: "截图要看出处、时间与上下文，多方信息互相印证，才算基本立得住。" },
  { no: "3", icon: "ri-cup-line", title: "最后安心吃瓜", desc: "理性围观作品与业务能力，尊重当事人作为普通人的一面，饭后图个乐。" },
];

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6 md:py-16">
        <SectionHead
          eyebrow="Guide · 追瓜指南"
          title="追瓜也能吃出姿势感"
          sub="瓜可以热，但不能乱。这里有一套编辑部每天都在用的吃瓜方法论，分享给同样爱追星娱热点的你。"
        />

        <div className="grid gap-6 md:grid-cols-3">
          {steps.map((s) => (
            <article key={s.no} className="rounded-2xl border border-background-200 bg-background-50 p-6 transition hover:border-background-300">
              <div className="flex items-center justify-between">
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <span className="font-heading text-4xl font-black text-background-300">0{s.no}</span>
              </div>
              <h3 className="font-heading mt-5 text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">{s.desc}</p>
            </article>
          ))}
        </div>

        {/* 口碑 */}
        <div className="mt-14 grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <h3 className="font-heading text-2xl font-bold text-foreground-950">瓜友怎么说</h3>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              上线以来，越来越多的追瓜朋友习惯在饭后点开「刚刚爆料」。评论区常有人问我们是怎么做到又全又稳的——其实答案很简单：把瓜当新闻做，把读者当朋友处。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl bg-background-50 p-4 text-center ring-1 ring-background-200">
                  <div className="font-heading text-2xl font-black text-primary-600">{s.value}</div>
                  <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4 lg:col-span-7">
            {voices.map((v) => (
              <figure key={v.name} className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center gap-2 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-7 text-foreground-700">“{v.text}”</blockquote>
                <figcaption className="mt-4 flex items-center justify-between">
                  <span className="flex items-center gap-2.5">
                    <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                      {v.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-900">{v.name}</span>
                      <span className="text-xs text-foreground-500">{v.role}</span>
                    </span>
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600">
                    <i className="ri-thumb-up-fill" />
                    {v.like}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}